import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OnBoardProgressService { 
  private currentStepSource = new BehaviorSubject<number>(0);

  currentStep$ = this.currentStepSource.asObservable();

  private valueChangedSource = new BehaviorSubject<any>(null);
  valueChanged$ = this.valueChangedSource.asObservable();

  private doNotShowMenu = new BehaviorSubject<any>(null);
  doNotShowMenu$ = this.doNotShowMenu.asObservable();

  constructor() { }

  private completedSteps = new Set<string>();

  markStepComplete(step: string) {
    this.completedSteps.add(step);
  }

  isStepComplete(step: string): boolean {
    return this.completedSteps.has(step);
  }

  getProgress(): string[] {
    return Array.from(this.completedSteps);
  }

  reset() {
    this.completedSteps.clear();
  }

  sendCurrentStepData(newValue: any) {
    this.valueChangedSource.next(newValue);
  }

  sendDoNotShowMenuInfo(newValue: any) {
    this.doNotShowMenu.next(newValue);
  }
}
